<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import Promise from 'bluebird'

import venueService from 'api/venue'
import urlUtils from 'utils/urlUtils'
import config from 'src/config'
import analyticsLib from 'lib/analytics'

export default {
  name: 'venue-app',
  data() {
    return {
      loading: true,
      venueId: this.$route.params.venueId,
      attributionId: this.$route.query.attributionId,
      quantity: parseInt(this.$route.query.quantity || 1, 10),
      client: this.$route.query.client,
    }
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
    }),
    venueHeaderStyles() {
      const styles = {}

      if (this.venue) {
        if (this.venue.primaryImage && this.venue.primaryImage.filename) {
          styles['background-image'] = `url(${urlUtils.optimizedImageUrl(this.venue.primaryImage.filename, {
            height: 400,
          })})`
        }
      }

      return styles
    },
  },
  methods: {
    initVenueAnalytics() {
      analyticsLib.init(this.venue)
    },
    getVenue() {
      return venueService
        .getById(this.venueId)
        .then((result) => {
          this.$store.dispatch('setCurrentVenue', result.data)

          this.initVenueAnalytics()
        })
        .catch((error) => {
          this.$store.dispatch('addTopBarNotification', {
            text: error.message,
          })
        })
    },
    initChat() {
      if (!this.venue || !this.venue.subscriptionAddOns || !this.venue.subscriptionAddOns.customerChat) return

      const scriptEl = document.createElement('script')
      scriptEl.src = `${config.WIDGETS_EMBED_URL}/embed.js`

      document.body.appendChild(scriptEl)

      setTimeout(() => {
        const widget = new window.TablelistWidgets.widgets.ChatWidget()

        widget.init({
          venueId: this.venueId,
        })
      }, 1000)
    },
  },
  mounted() {
    this.loading = true

    Promise.all([this.getVenue(), this.$store.dispatch('setConfigAttributionId', this.attributionId), this.$store.dispatch('setConfigClient', this.client)]).then(() => {
      this.loading = false

      this.initChat()

      return null
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Venue/VenueApp/index.vue